module.exports = __webpack_public_path__ + "static/img/are-you-driver-enough.4b76932.svg";


//////////////////
// WEBPACK FOOTER
// ./src/modules/simon-game/assets/are-you-driver-enough.svg
// module id = dmla
// module chunks = 1